import {
	LONG_TIME_COOKIE_EXPIRATION,
	HIGH_CONTRAST_COOKIE,
	HIGH_CONTRAST_MODE_BODY_CLASS
} from '../../constants/consts';
import { mapActions } from 'vuex';

export default {
	data() {
		return {
			highContrast: false,
			id: null
		};
	},
	mounted() {
		this.id = this._uid;
	},
	created() {
		this.initHighContrastMode();
	},
	methods: {
		initHighContrastMode() {
			this.highContrast = !!this.$cookie.get(HIGH_CONTRAST_COOKIE);
			if (this.highContrast) {
				document.body.classList.add(HIGH_CONTRAST_MODE_BODY_CLASS);
			} else {
				document.body.classList.remove(HIGH_CONTRAST_MODE_BODY_CLASS);
			}
			this.setHighContrastMode(this.highContrast);
		},
		...mapActions('common', ['setHighContrastMode'])
	},
	watch: {
		highContrast(newValue) {
			let highContrast = !!newValue;
			if (highContrast) {
				this.$cookie.set(HIGH_CONTRAST_COOKIE, highContrast, {expires: LONG_TIME_COOKIE_EXPIRATION });
				document.body.classList.add(HIGH_CONTRAST_MODE_BODY_CLASS);
			} else {
				this.$cookie.delete(HIGH_CONTRAST_COOKIE);
				document.body.classList.remove(HIGH_CONTRAST_MODE_BODY_CLASS);
			}
			this.setHighContrastMode(highContrast);
		}
	}
};
